import { examAdminExecutionAttackDefense } from "./exam-admin-execution-attack-defense";

export const examAdminExecution = {
  pageTitle: "夺旗环境管理",
  submissions: "代码提交记录",
  pageSubtitle: "统一查看环境实例、夺旗题运行态和编程题判题提交记录。",
  submissionsPageSubtitle: "统一查看编程题判题提交记录与管理员试运行记录。",
  submissionDetailDefault: "提交详情",
  submissionDetailTryRun: "提交详情 {id}",
  submissionDetailRecord: "提交详情 #{id}",
  attackDefensePanel: examAdminExecutionAttackDefense,
  sections: {
    environments: "环境实例",
    submissions: "代码提交记录",
  },
  stats: {
    environmentTotal: "环境实例总数：{count}",
    environmentActive: "活跃环境：{count}",
    environmentAnomaly: "环境异常：{count}",
    submissionTotal: "代码提交总数：{count}",
    submissionAccepted: "Accepted：{count}",
    submissionNonAccepted: "非 Accepted：{count}",
  },
  filters: {
    activeOnly: "仅看活跃环境",
    anomalyOnly: "仅看异常运行态",
    status: "按状态筛选",
    exam: "按考试筛选",
    candidate: "按考生筛选",
    nonAcceptedOnly: "仅看非 Accepted",
    verdict: "按 verdict 筛选",
  },
  actions: {
    viewAttempt: "查看 Attempt",
    recycleInstance: "回收实例",
    rejudge: "重新判题",
    batchRecycle: "批量回收已选实例",
    exportEnvironments: "导出当前环境结果",
    exportSubmissions: "导出当前提交结果",
    batchRejudge: "批量重判已选题目",
  },
  messages: {
    instanceDestroySubmitted: "环境实例销毁请求已提交",
    batchDestroySubmissionPartial: "批量销毁请求已提交 {submitted} 个，失败 {failed} 个",
    batchDestroySubmissionSuccess: "批量销毁请求已提交，共 {count} 个",
    rejudgeSuccess: "重新判题完成",
    batchRejudgePartial: "批量重判完成，成功 {success} 个，失败 {failed} 个",
    batchRejudgeSuccess: "批量重判完成，共 {count} 个",
  },
  confirm: {
    recycleTitle: "确认回收该环境实例？",
    recycleDescription: "回收后会从运行态切到 destroyed。",
    recycleSubmit: "回收",
    batchRecycleTitle: "确认批量回收选中的环境实例？",
    batchRecycleDescription: "只会对未 destroyed 的实例执行回收。",
    batchRecycleSubmit: "批量回收",
    batchRejudgeTitle: "确认批量重判当前选中的题目？",
    batchRejudgeDescription: "按 attempt_question 去重后重新生成最新判题结果。",
    batchRejudgeSubmit: "批量重判",
  },
  table: {
    instanceId: "实例 ID",
    examAttempt: "考试 / Attempt",
    question: "题目",
    types: "类型",
    source: "来源",
    questionVersionCode: "题目版本编号",
    runStatus: "运行状态",
    caseResult: "用例结果",
    operator: "操作者",
    language: "语言",
    memory: "运行内存",
    time: "运行时间",
    action: "操作",
    case: "用例",
    input: "输入",
    expectedOutput: "期望输出",
    actualOutput: "实际输出",
    errorInfo: "错误信息",
    timeUsedMs: "耗时(ms)",
    memoryUsedMb: "内存(MB)",
    providerRef: "提供者引用",
    submissionId: "提交 ID",
    languageAndCount: "语言 / 次数",
    judgeStatus: "判题状态",
    submittedAt: "提交时间",
    questionMeta: "Q#{questionId} / 第 {order} 题 / 考生 #{candidateId}",
    examLabel: "考试 #{id}",
    attemptLabel: "作答 #{id}",
    candidateLabel: "考生 #{id}",
    adminTryRun: "试运行",
    unknown: "未知",
    contractValueMissing: "缺失",
    sourceTypeContractAnomaly: "来源合同异常：{value}",
    flagModeContractAnomaly: "Flag 模式合同异常：{value}",
    acceptedSummary: "{passed} 通过 / {failed} 未通过",
    codeSnapshot: "提交代码",
    caseResults: "用例结果",
    runSuccess: "运行成功",
    runFailed: "运行失败",
    runRunning: "运行中",
    runStatusContractAnomaly: "运行状态合同异常：{value}",
    runVerdictContractAnomaly: "运行结果合同异常：{value}",
    caseAccepted: "通过",
    caseFailed: "失败",
    caseStatusContractAnomaly: "用例状态合同异常：{value}",
  },
};
